<div *ngIf="isVisible()">
    <hs-panel-header name="'strategy'"
        [title]="HsLanguageService.getTranslationIgnoreNonExisting('STRATEGY','panelTitle')"></hs-panel-header>
    <ng-template #noPlaceSelected>
        <div class="card hs-main-panel" *ngIf="!StrategyCommonService.selectedCoords">
            <div class="d-flex flex-column align-items-center p-4">
                <i class="icon-cursor bg-primary p-3 text-white rounded "
                    style="font-size: x-large; color:hsl(208, 100%, 97%)"></i>
                <p class="h4">{{HsLanguageService.getTranslationIgnoreNonExisting('STRATEGY','noPlaceSelected')}}</p>
                <p class="small">{{HsLanguageService.getTranslationIgnoreNonExisting('QUERY.infoPanel','clickOnMap')}}
                </p>
            </div>
        </div>
    </ng-template>
    <div *ngIf="StrategyCommonService.selectedCoords; else noPlaceSelected" class="pt-1">
        <ul class="nav nav-tabs mx-2 ">
            <li class="nav-item" *ngFor="let type of overviewTypes" (click)="overviewSelected(type.value)">
                <a class="nav-link" [ngClass]="{'active': StrategyCommonService.overview == type.value}"
                    href="#">{{HsLanguageService.getTranslationIgnoreNonExisting('STRATEGY.overviewTypes',type.value)}}</a>
            </li>
        </ul>
        <div class="ac-chartplace position-relative">
            <nav class="navbar navbar-expand-lg navbar-light bg-light my-2 mx-1 ">
                <div class="collapse navbar-collapse justify-content-between d-flex" id="navbarNav">
                    <div class="d-flex align-items-center">
                        <button type="button" class="btn btn-sm btn-light btn-outline-primary mr-2"
                            (click)="toggleChartZoom()" [ngClass]="{'active': StrategyBaseChartsService.zoom}" [title]="HsLanguageService.getTranslationIgnoreNonExisting('STRATEGY',
                            'zoomToChart')">
                            <i class="icon-search"></i>
                        </button>
                        <div *ngIf="StrategyCommonService.overview == 'crop'"
                            class="d-flex flex-row align-items-center">
                            <span class="mr-2">{{HsLanguageService.getTranslationIgnoreNonExisting('STRATEGY',
                                'crop')}}:</span>
                            <div class="dropdown">
                                <button class="btn btn-sm btn-light btn-outline-secondary dropdown-toggle" type="button"
                                    data-toggle="dropdown" aria-haspopup="true" [attr.aria-expanded]="cropsExpanded"
                                    (click)="cropsExpanded = !cropsExpanded;">
                                    <span
                                        class="mx-1 font-weight-bold">{{HsLanguageService.getTranslationIgnoreNonExisting('STRATEGY.crops',
                                        StrategyCommonService.selectedCrop)}}</span>
                                </button>
                                <div class="dropdown-menu" [ngClass]="{'show': cropsExpanded}">
                                    <a *ngFor="let crop of StrategyCommonService.crops" (click)="cropSelected(crop)"
                                        class="dropdown-item"
                                        href="#">{{HsLanguageService.getTranslationIgnoreNonExisting('STRATEGY.crops',
                                        crop)}}</a>
                                </div>
                            </div>
                        </div>
                        <form class="form-inline mx-4">
                            <div class="form-group">
                                <div class="input-group border">
                                    <input class="form-control form-control-sm datePickerInput border-0" readonly
                                        [title]="HsLanguageService.getTranslationIgnoreNonExisting('STRATEGY',
                                    'seasonStart')" placeholder="yyyy-mm-dd" name="dp"
                                        (dateSelect)="seasonStartDateSelected($event)"
                                        [(ngModel)]="StrategyCommonService.seasonStartDate"
                                        [minDate]="StrategyCommonService.calendarMin"
                                        [maxDate]="StrategyCommonService.calendarMax" #d="ngbDatepicker" ngbDatepicker
                                        [placement]="'bottom'" [footerTemplate]="footerTemplate"
                                        [positionTarget]="dateToggle" showWeekNumbers="true">
                                    <div class="input-group-append">
                                        <button #dateToggle [title]="HsLanguageService.getTranslationIgnoreNonExisting('STRATEGY',
                                        'changeSeasonStart')"
                                            class="btn btn-outline-secondary calendar btn-sm rounded border-0"
                                            (click)="d.toggle()" type="button"><i
                                                class="icon-calendarthree"></i></button>
                                    </div>
                                </div>
                                <ng-template #footerTemplate>
                                    <div class="d-flex datePickerFooter bg-primary text-white">
                                        <p class="m-0">
                                            {{HsLanguageService.getTranslationIgnoreNonExisting('STRATEGY',
                                            'seasonStart')}}</p>
                                        {{StrategyCommonService.seasonStartDate.day}}.{{StrategyCommonService.seasonStartDate.month}}
                                    </div>
                                </ng-template>
                            </div>
                        </form>
                    </div>
                    <div *ngIf="StrategyBaseChartsService.dataFrequency == 'week'">
                        {{HsLanguageService.getTranslationIgnoreNonExisting('STRATEGY','selectedYear')}}:
                        {{StrategyCommonService.selectedDate.upper}}
                    </div>

                    <div class="d-flex">
                        <div class="mr-3">
                            <button type="button" class="btn btn-sm btn-light btn-outline-primary"
                                (click)="uncertainityToggled()" [disabled]="ChartsService.generatingCharts"
                                [ngClass]="{'active': StrategyCommonService.uncertainity}">{{HsLanguageService.getTranslationIgnoreNonExisting('CHARTS','uncertainity')}}</button>
                        </div>

                        <div class="btn-group">
                            <button type="button" class="btn btn-sm btn-light btn-outline-secondary"
                                [disabled]="ChartsService.generatingCharts"
                                (click)="StrategyCommonService.dataFrequencyChanged('week')"
                                [ngClass]="{'active':StrategyBaseChartsService.dataFrequency == 'week'}">
                                {{HsLanguageService.getTranslationIgnoreNonExisting('CHARTS.dataFrequency', 'week')}}
                            </button>
                            <button type="button" class="btn btn-sm btn-light btn-outline-secondary"
                                [disabled]="ChartsService.generatingCharts"
                                (click)="StrategyCommonService.dataFrequencyChanged('year')"
                                [ngClass]="{'active':StrategyBaseChartsService.dataFrequency == 'year'}">
                                {{HsLanguageService.getTranslationIgnoreNonExisting('CHARTS.dataFrequency', 'year')}}
                            </button>
                        </div>
                    </div>
                </div>
            </nav>
            <div [hidden]="!ChartsService.generatingCharts" class="loadingContainer w-50 rounded">
                <div class="d-flex justify-content-center align-items-center">
                    <img class="pr-2" [src]="loaderImage" style="width: 3em" />
                    <span
                        class="loadingText text-secondary">{{HsLanguageService.getTranslationIgnoreNonExisting('STRATEGY',
                        'generatingCharts')}}</span>
                </div>
            </div>

            <div [ngClass]="{'opacityLowered' : ChartsService.generatingCharts}">
                <ac-charts
                    *ngIf="StrategyCommonService.dataFrequency == 'week' && StrategyCommonService.overview == 'place'"
                    [ngStyle]="{'cursor' : StrategyBaseChartsService.zoom ? 'pointer' : 'default'}"
                    [data]="StrategyClimaService.climaDiagramData"
                    class="strategyDataContainer d-flex justify-content-center" style="width: 100%; height:100%">
                </ac-charts>
                <ac-charts [ngStyle]="{'cursor' : StrategyBaseChartsService.zoom ? 'pointer' : 'default'}"
                    [data]="StrategyBaseChartsService.strategyChartData"
                    class="strategyDataContainer d-flex justify-content-center" style="width: 100%; height:100%">
                </ac-charts>
            </div>
        </div>
    </div>
</div>